<ng-container [ngSwitch]='layoutType'>

  <!-- INSIGHTS LAYOUT -->
  <div class='wrapper-insights' *ngSwitchCase="'insights'">
    <app-insights-layout
      [isLoggedIn]='isLoggedIn'>
    </app-insights-layout>
  </div>

  <!-- DEFAULT WRAPPER FOR OTHER LAYOUTS -->
  <div class='wrapper' *ngSwitchDefault>
    <app-navbar *ngIf='canShowAppNavbar()' class='fixed-top'></app-navbar>

    <div [class]="canShowAppNavbar()? 'router-outlet' : 'router-outlet m-0'" class="main-content-wrapper">

      <div class="main-content-fill">
      <ng-container [ngSwitch]='layoutType'>
        <!-- SIMPLE LAYOUT -->
        <ng-container *ngSwitchCase="'simple'">
          <app-simple-layout></app-simple-layout>
        </ng-container>

        <!-- CMS LAYOUT -->
        <ng-container *ngSwitchCase="'cms'">
          <app-cms-layout
            [cmsTitle]='cmsTitle'>
          </app-cms-layout>
        </ng-container>

        <!-- SETTINGS LAYOUT -->
        <ng-container *ngSwitchCase="'settings'">
          <app-settings-layout></app-settings-layout>
        </ng-container>

        <!-- MAIN LAYOUT -->
        <ng-container *ngSwitchDefault>
          <div *ngIf='!isLoggedIn || isUserProfileNotCreated()' class='container-fluid'>
            <div class='row'>
              <div class='col-12 col-md-12 col-lg-12 p-0'>
                <router-outlet></router-outlet>
              </div>
            </div>
          </div>

          <app-main-layout *ngIf='canShowBreadcrumbs()'
                           [isHome]='isHome'
                           [isLoggedIn]='isLoggedIn'
                           [breadcrumbs$]='breadcrumbs$'
                           [breadcrumbVariable]='breadcrumbVariable'
                           [canShowCarousel]='canShowCarousel()'>
          </app-main-layout>
        </ng-container>
      </ng-container>
      </div>

      <!-- FOOTER -->
      <div *ngIf='layoutType !== "simple"' class="footer-sticky">
        <app-footer></app-footer>
      </div>
    </div>

  </div>
</ng-container>
